/* tslint:disable */
/* eslint-disable */
/**
 * Green0meter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AssignmentUserBasicsDto } from '../models';
// @ts-ignore
import type { AssignmentsConfigFormBasicsDto } from '../models';
// @ts-ignore
import type { CompanyAssignmentConfigDto } from '../models';
// @ts-ignore
import type { FormAssignmentConfigDto } from '../models';
// @ts-ignore
import type { FormSectionAssignmentConfigBasicDto } from '../models';
// @ts-ignore
import type { GetCompanyAssignmentConfigDto } from '../models';
// @ts-ignore
import type { UpdateFormAssignmentDto } from '../models';
/**
 * AssignmentsConfigApi - axios parameter creator
 * @export
 */
export const AssignmentsConfigApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {Array<string>} companyIds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentsConfigControllerGetAssignableUsers: async (companyIds: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyIds' is not null or undefined
            assertParamExists('assignmentsConfigControllerGetAssignableUsers', 'companyIds', companyIds)
            const localVarPath = `/api/assignments-config/assignable-users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (companyIds) {
                localVarQueryParameter['companyIds'] = companyIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetCompanyAssignmentConfigDto} getCompanyAssignmentConfigDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentsConfigControllerGetCompaniesAssignmentConfig: async (getCompanyAssignmentConfigDto: GetCompanyAssignmentConfigDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'getCompanyAssignmentConfigDto' is not null or undefined
            assertParamExists('assignmentsConfigControllerGetCompaniesAssignmentConfig', 'getCompanyAssignmentConfigDto', getCompanyAssignmentConfigDto)
            const localVarPath = `/api/assignments-config/get-companies-assignment-config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getCompanyAssignmentConfigDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} formId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentsConfigControllerGetFormAssignmentConfig: async (formId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'formId' is not null or undefined
            assertParamExists('assignmentsConfigControllerGetFormAssignmentConfig', 'formId', formId)
            const localVarPath = `/api/assignments-config/{formId}/config`
                .replace(`{${"formId"}}`, encodeURIComponent(String(formId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentsConfigControllerGetFormsBasics: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/assignments-config/forms-basics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateFormAssignmentDto} updateFormAssignmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentsConfigControllerUpdateFormAssignment: async (updateFormAssignmentDto: UpdateFormAssignmentDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateFormAssignmentDto' is not null or undefined
            assertParamExists('assignmentsConfigControllerUpdateFormAssignment', 'updateFormAssignmentDto', updateFormAssignmentDto)
            const localVarPath = `/api/assignments-config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateFormAssignmentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AssignmentsConfigApi - functional programming interface
 * @export
 */
export const AssignmentsConfigApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AssignmentsConfigApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {Array<string>} companyIds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignmentsConfigControllerGetAssignableUsers(companyIds: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AssignmentUserBasicsDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignmentsConfigControllerGetAssignableUsers(companyIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssignmentsConfigApi.assignmentsConfigControllerGetAssignableUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GetCompanyAssignmentConfigDto} getCompanyAssignmentConfigDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignmentsConfigControllerGetCompaniesAssignmentConfig(getCompanyAssignmentConfigDto: GetCompanyAssignmentConfigDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CompanyAssignmentConfigDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignmentsConfigControllerGetCompaniesAssignmentConfig(getCompanyAssignmentConfigDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssignmentsConfigApi.assignmentsConfigControllerGetCompaniesAssignmentConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} formId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignmentsConfigControllerGetFormAssignmentConfig(formId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FormAssignmentConfigDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignmentsConfigControllerGetFormAssignmentConfig(formId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssignmentsConfigApi.assignmentsConfigControllerGetFormAssignmentConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignmentsConfigControllerGetFormsBasics(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AssignmentsConfigFormBasicsDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignmentsConfigControllerGetFormsBasics(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssignmentsConfigApi.assignmentsConfigControllerGetFormsBasics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateFormAssignmentDto} updateFormAssignmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignmentsConfigControllerUpdateFormAssignment(updateFormAssignmentDto: UpdateFormAssignmentDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FormSectionAssignmentConfigBasicDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignmentsConfigControllerUpdateFormAssignment(updateFormAssignmentDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssignmentsConfigApi.assignmentsConfigControllerUpdateFormAssignment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AssignmentsConfigApi - factory interface
 * @export
 */
export const AssignmentsConfigApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AssignmentsConfigApiFp(configuration)
    return {
        /**
         * 
         * @param {Array<string>} companyIds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentsConfigControllerGetAssignableUsers(companyIds: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<Array<AssignmentUserBasicsDto>> {
            return localVarFp.assignmentsConfigControllerGetAssignableUsers(companyIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetCompanyAssignmentConfigDto} getCompanyAssignmentConfigDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentsConfigControllerGetCompaniesAssignmentConfig(getCompanyAssignmentConfigDto: GetCompanyAssignmentConfigDto, options?: RawAxiosRequestConfig): AxiosPromise<Array<CompanyAssignmentConfigDto>> {
            return localVarFp.assignmentsConfigControllerGetCompaniesAssignmentConfig(getCompanyAssignmentConfigDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} formId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentsConfigControllerGetFormAssignmentConfig(formId: string, options?: RawAxiosRequestConfig): AxiosPromise<FormAssignmentConfigDto> {
            return localVarFp.assignmentsConfigControllerGetFormAssignmentConfig(formId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentsConfigControllerGetFormsBasics(options?: RawAxiosRequestConfig): AxiosPromise<Array<AssignmentsConfigFormBasicsDto>> {
            return localVarFp.assignmentsConfigControllerGetFormsBasics(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateFormAssignmentDto} updateFormAssignmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentsConfigControllerUpdateFormAssignment(updateFormAssignmentDto: UpdateFormAssignmentDto, options?: RawAxiosRequestConfig): AxiosPromise<Array<FormSectionAssignmentConfigBasicDto>> {
            return localVarFp.assignmentsConfigControllerUpdateFormAssignment(updateFormAssignmentDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AssignmentsConfigApi - object-oriented interface
 * @export
 * @class AssignmentsConfigApi
 * @extends {BaseAPI}
 */
export class AssignmentsConfigApi extends BaseAPI {
    /**
     * 
     * @param {Array<string>} companyIds 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssignmentsConfigApi
     */
    public assignmentsConfigControllerGetAssignableUsers(companyIds: Array<string>, options?: RawAxiosRequestConfig) {
        return AssignmentsConfigApiFp(this.configuration).assignmentsConfigControllerGetAssignableUsers(companyIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetCompanyAssignmentConfigDto} getCompanyAssignmentConfigDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssignmentsConfigApi
     */
    public assignmentsConfigControllerGetCompaniesAssignmentConfig(getCompanyAssignmentConfigDto: GetCompanyAssignmentConfigDto, options?: RawAxiosRequestConfig) {
        return AssignmentsConfigApiFp(this.configuration).assignmentsConfigControllerGetCompaniesAssignmentConfig(getCompanyAssignmentConfigDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} formId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssignmentsConfigApi
     */
    public assignmentsConfigControllerGetFormAssignmentConfig(formId: string, options?: RawAxiosRequestConfig) {
        return AssignmentsConfigApiFp(this.configuration).assignmentsConfigControllerGetFormAssignmentConfig(formId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssignmentsConfigApi
     */
    public assignmentsConfigControllerGetFormsBasics(options?: RawAxiosRequestConfig) {
        return AssignmentsConfigApiFp(this.configuration).assignmentsConfigControllerGetFormsBasics(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateFormAssignmentDto} updateFormAssignmentDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssignmentsConfigApi
     */
    public assignmentsConfigControllerUpdateFormAssignment(updateFormAssignmentDto: UpdateFormAssignmentDto, options?: RawAxiosRequestConfig) {
        return AssignmentsConfigApiFp(this.configuration).assignmentsConfigControllerUpdateFormAssignment(updateFormAssignmentDto, options).then((request) => request(this.axios, this.basePath));
    }
}

